import * as _ from 'lodash';
import { Glyphicon, Row } from 'react-bootstrap';
import { ToDoColumnWrapper } from '../styles';
import { ActionItem } from '../models';
import { IAdminActionCenterOther } from '@nkr/models/index';
import ActionCenterItem from './action-center-item-count';
import { MainType } from './models/main-type';
import { useState } from 'react';

interface IProps {
    data: IAdminActionCenterOther,
    showLoading: boolean,
    hideEmptyItems: boolean,
    isAdmin: boolean,
    onItemClick: (mainType: MainType, subType: ActionItem) => void
}

const OtherCountsOnly = (props: IProps) => {
    const [expanded, setExpanded] = useState(true);

    const handleItemClick = (subType: ActionItem) => {
        props.onItemClick(MainType.Other, subType);
    };

    const logisticsCallCount = props.data != null ? props.data.logisticsCallCount : 0;
    const kickoffCallCount = props.data != null ? props.data.kickoffCallCount : 0;
    const pickupCount = props.data != null ? props.data.pickupCount : 0;
    const deliveryCount = props.data != null ? props.data.deliveryCount : 0;
    const ldPrioritizationCount = props.data != null ? props.data.ldPrioritizationCount : 0;
    const watrRequestCount = props.data != null ? props.data.watrRequestCount : 0;
    const voucherDonorsWithIncompleteVoucherHoldersCount = props.data != null ? props.data.voucherDonorsWithIncompleteVoucherHoldersCount : 0;
    const incompleteVoucherDonorCount = props.data != null ? props.data.incompleteVoucherDonorCount : 0;

    const items = [
        { name: 'Logistics Calls', count: logisticsCallCount, actionItem: ActionItem.LogisticsKickoffCalls },
        { name: 'Kickoff Calls', count: kickoffCallCount, actionItem: ActionItem.LogisticsKickoffCalls },
        { name: 'Transplant Pickups', count: pickupCount, actionItem: ActionItem.TransplantPickup },
        { name: 'Transplant Deliveries', count: deliveryCount, actionItem: ActionItem.TransplantDelivery },
        { name: 'Donors Missing LD Priorization', count: ldPrioritizationCount, actionItem: ActionItem.LdPrioritization },
        { name: 'WaTR Requests', count: watrRequestCount, actionItem: ActionItem.WageAndTravelRequests },
        { name: 'Voucher Donors w/ Incomplete Holders', count: voucherDonorsWithIncompleteVoucherHoldersCount, actionItem: ActionItem.VoucherDonors },
        { name: 'Incomplete Voucher Donors', count: incompleteVoucherDonorCount, actionItem: ActionItem.VoucherDonors },
    ];

    const isEmpty = items.filter(x => x.count == 0).length == items.length;
    const itemCount = items.filter(x => x.count > 0).length;
    const itemList = _.sortBy(items, item => item.name);

    let title = props.isAdmin ? 'OTHER - All Centers' : 'OTHER';

    return (
        <div className='section-other'>
            <div className='title-container'>
                <div className={props.isAdmin ? 'title admin-title' : 'title'} onClick={() => setExpanded(!expanded)}>
                    <h4>{title} <span>({itemCount})</span></h4>
                    <span style={{ paddingLeft: 5 }}><Glyphicon glyph={expanded ? 'chevron-down' : 'chevron-up'} /></span>
                </div>
                <div style={{ borderBottom: '1px solid cadetblue', width: '85%' }}>&nbsp;</div>
            </div>
            {expanded ?
                <div className='content' style={{ backgroundColor: props.showLoading ? '#eee' : null, opacity: props.showLoading ? 0.5 : 1 }}>
                    {props.showLoading && (
                        <div className="loader"><div className='message'>Loading upcoming items, one moment please...</div></div>
                    )}

                    <div className='container-fluid'>
                        <Row>
                            {itemList.map((item, index) => {
                                if ((!props.hideEmptyItems && item.count == 0) || item.count > 0) {
                                    return (
                                        <ToDoColumnWrapper key={index} className='col-xs-12 col-lg-6'>
                                            <ActionCenterItem
                                                description={item.name}
                                                count={item.count}
                                                isList={true}
                                                color='black'
                                                highlight='aliceblue'
                                                actionItem={item.actionItem}
                                                onItemClick={handleItemClick}
                                            />
                                        </ToDoColumnWrapper>
                                    )
                                }
                            })}
                        </Row>

                        {isEmpty && props.hideEmptyItems && (
                            <ToDoColumnWrapper className='col-xs-12 col-lg-12' style={{ fontSize: 16 }}>
                                At this time, there are no upcoming items
                            </ToDoColumnWrapper>
                        )}
                    </div>
                </div>
                :
                <div className='content collapsed'></div>
            }
        </div>
    )
}

export default OtherCountsOnly;